import type React from 'react';

import { StaffDrawer, StaffDrawerInfo, StaffDrawerLink, StaffDrawerSection } from '#src/app/shared/components/staff';

import { useMovementStaffDrawer } from './hooks/useMovementStaffDrawer';

export const MovementStaffDrawer: React.FC<EmptyProps> = () => {
	const {
		data: { movementId, slug, petitionCount, createdAt, updatedAt, ownerId, urls },
	} = useMovementStaffDrawer();

	return (
		<StaffDrawer>
			<StaffDrawerSection title="Movement">
				<StaffDrawerInfo label="Movement ID" value={movementId} copyable />
				<StaffDrawerInfo label="Slug" value={slug} copyable />
				<StaffDrawerInfo label="Petition count" value={petitionCount} />
				<StaffDrawerInfo label="Created" value={createdAt} />
				<StaffDrawerInfo label="Updated" value={updatedAt} />
				<StaffDrawerLink href={urls.movementAdmin}>Movement admin</StaffDrawerLink>
				<StaffDrawerLink href={urls.addPetitions}>Add petitions</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Owner">
				<StaffDrawerInfo label="User ID" value={ownerId} copyable />
				<StaffDrawerLink href={urls.userAdmin}>User admin</StaffDrawerLink>
			</StaffDrawerSection>
		</StaffDrawer>
	);
};
